require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#de9921',
        accent: '#9c6a0f',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
      dark: {
        primary: '#f9e36a',
        accent: '#de9921',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
    },
  },
}
